import { useMutation, useQueryClient } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { reportExportTaskRepository } from '@webapp/modules/reports/data-access/repositories/ReportExportTaskRepository'
import { EXPORT_TASK_BASE_KEY } from '@webapp/modules/reports/query-configs/exportTaskQueries'

// Command-only Model (feature-level CQS). Invalidating the export-task
// base key refetches the mounted list-export-tasks query immediately —
// the deleted row disappears without a manual refetch (BHV-037).
export const useMutateDeleteExportTask = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation<void, RepoError, string>({
    mutationFn: (uuid) => reportExportTaskRepository.delete(uuid),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: EXPORT_TASK_BASE_KEY })
    },
  })

  return {
    deleteExportTask: mutation.mutateAsync,
    isLoading: mutation.isLoading,
    isError: mutation.isError,
    error: mutation.error,
  }
}
